import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Col, Row } from "reactstrap";

class BreadcrumbsMass extends Component {
  render() {
    return (
      <React.Fragment>
        
            <div className="page-title-box align-items-center">
              <h5 className="mb-0 font-size-18">{this.props.breadcrumbItem}</h5>
              <div className="bdLeft">
              <Link to="#">&nbsp;</Link>
              </div>
              
            </div>
          
      </React.Fragment>
    )
  }
}

BreadcrumbsMass.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string
}

export default BreadcrumbsMass
